import { gql, TypedDocumentNode } from "@apollo/client";

export const StylesFindByVendor: TypedDocumentNode<{stylesFindByVendor: string[]}, {vendorId: number}> = gql`
    query StylesFindByVendor($vendorId: Int!) {
        stylesFindByVendor(vendorId: $vendorId)
    }
`